module.exports = __webpack_public_path__ + "static/media/DLSample.2d997793.jpg";